export default __webpack_public_path__ + "static/MittagstischLight-df6be1a214dc653c99b9b4df15415d99.png";